import { render, staticRenderFns } from "./shopItem.vue?vue&type=template&id=dd685cd0&scoped=true"
import script from "./shopItem.vue?vue&type=script&lang=js"
export * from "./shopItem.vue?vue&type=script&lang=js"
import style0 from "./shopItem.vue?vue&type=style&index=0&id=dd685cd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd685cd0",
  null
  
)

export default component.exports